import { useSelector } from 'react-redux';
import { useFeatureEnabled } from 'Components/FeatureToggle';

/**
 * Support Chat in unit troubleshooting should follow the chat service that is
 * actually available. The header chat uses Salesforce Messaging (`support-chat`).
 * Live Agent availability is only meaningful while the legacy widget is in use.
 */
export const useSupportChatAvailable = () => {
    const enableNewSupportChat = useFeatureEnabled('support-chat');
    const isAgentAvailable = useSelector(
        (state) => state.troubleshootDeviceRedux.isAgentAvailable
    );

    return enableNewSupportChat || Boolean(isAgentAvailable);
};
